/**
 * WebsocketTokenMap
 * ---------------------------------------
 * Egy egyszerű, singleton jellegű in-memory tároló,
 * amely channel név alapján képes websocket tokeneket tárolni.
 *
 * Mire használható?
 * - opcionális kliensoldali websocket token kezeléshez
 * - private / presence channel auth kiegészítéséhez
 * - channel → token párosítás kezelésére
 *
 * Fontos:
 * - ez egy in-memory tároló (nem perzisztens)
 * - oldalfrissítéskor a tokenek elvesznek
 *
 * Megjegyzés:❗
 * - a jelenlegi projektben nincs aktív használatban
 * - egy jövőbeli, haladó websocket (pl. whisper / client event) logikához lett előkészítve
 */

const WebsocketTokenMap = new class WebsocketTokenMap {
    tokens = {};

    set(channelName, token) {
        this.tokens[channelName] = token;

        return this;
    }

    get(channelName) {
        return this.tokens[channelName] ?? null;
    }

    has(channelName) {
        return this.tokens.hasOwnProperty(channelName);
    }

    remove(channelName) {
        delete this.tokens[channelName];
        return this;
    }
};

function useWebsocketTokenMap() {
    return WebsocketTokenMap;
}

export { useWebsocketTokenMap };